import {AccountService} from "../../core/services/AccountService"
export class ForgetPasswordPageComponent implements ng.IComponentOptions {
    public controller: any = ForgetPasswordController;
    public template: string =
    `<div class="container container-fluid">
      <div class="row">
      <div class="col-xs-12 main-content">
      <div class="logincontainer">
        <div class="header-lined"><h1>Reset Password</h1></div>
        <span class="text-danger" ng-show="$ctrl.error.login">{{$ctrl.errorMsg}}</span>
        <p>Please Enter Your Email to Reset Your Password</p>
        <form role="form" name="loginForm">
          <div class="input-group margin-top">
            <span class="input-group-addon">
            <i class="fa fa-user"></i>
            </span>
            <input type="text" name="email" class="form-control" id="inputEmail" placeholder="Enter Email" autofocus="" ng-model="$ctrl.form.email" required>
          </div>
          <div class="clearfix margin-top-2">
            <button type="submit" class="btn btn-primary" ng-click="loginForm.$valid && $ctrl.forget()">Submit</button>
          </div>
        </form>
      </div>
      </div>
        </div>
    </div>`;
}
export class ForgetPasswordController {
    public static $inject: Array<string> = ["AccountService", "$location", "$window"];
    public tree: Array<Object>;
    public form: any;
    public error: any;
    public errorMsg: string;

    constructor(public account: AccountService, private $location: ng.ILocationService, private $window: ng.IWindowService) {
      this.tree = [
        {name: "Forget Password", path: "#/forget-password", active: true}
      ];
      this.error = {};
    }

    public forget(): void {
      this.account.forgetPassword(this.form.email)
      .then(() => {
        swal({
          type: "success",
          title: "Email Sent",
          text: `New Password has been sent to <strong>${this.form.email}</strong>`,
          html: true
        }, () => {
          this.$window.open("#/login", "_top");
        })
      })
      .catch(() => {
        swal("Sorry!", "The email is not existed or invalid.", "warning");
      })
    }

}
